import React, { memo, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { Modal, Text } from '@Sage/hoi-poi-ui';
import { getLiteral } from 'utils/getLiteral';

const EntityAccessErrorModal = memo(({ error, onClose }) => {
    const [portalElement, setPortalElement] = useState(null);

    useEffect(() => {
        // Create a div element to hold the portal
        const element = document.createElement('div');
        element.id = 'entity-access-error-portal';
        document.body.appendChild(element);
        setPortalElement(element);

        // Cleanup function
        return () => {
            document.body.removeChild(element);
        };
    }, []);

    if (!portalElement || !error) return null;

    return ReactDOM.createPortal(
        <Modal
            isOpen={true}
            onRequestClose={onClose}
            title={getLiteral('helptext_entity_not_accessible_title')}
            onConfirm={onClose}
            confirmText={getLiteral('action_close')}
            size="small"
        >
            <Text>{getLiteral('helptext_entity_not_accessible')}</Text>
        </Modal>,
        portalElement,
    );
});

EntityAccessErrorModal.propTypes = {
    error: PropTypes.object,
    onClose: PropTypes.func.isRequired,
};

EntityAccessErrorModal.defaultProps = {
    error: null,
};

export default EntityAccessErrorModal;
